import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { LoginPage } from '@/modules/auth/login-page';
import { AdminLayout } from '@/layouts/admin-layout';
import { OverviewPage } from '@/modules/overview/overview-page';
import { LiveMonitoringPage } from '@/modules/live-monitoring/live-monitoring-page';
import { MembersPage } from '@/modules/members/members-page';
import { ResourcePage } from '@/modules/shared/resource-page';
import { SystemHealthPage } from '@/modules/system-health/system-health-page';
import { ClubsPage } from '@/modules/groups/groups-page';
import { ConvoysPage } from '@/modules/trips/trips-page';
import { InviteHubPage } from '@/modules/invite-hub/invite-hub-page';
import { CreateRidePassPage } from '@/modules/invite-hub/create-ride-pass-page';
import { RidePassDetailPage } from '@/modules/invite-hub/ride-pass-detail-page';
import { VoiceRoomsPage } from '@/modules/voice-rooms/voice-rooms-page';
import { RiderLinkPage } from '@/modules/rider-link/rider-link-page';
import { MediaSessionsPage } from '@/modules/media-sessions/media-sessions-page';
import { NotificationsPage } from '@/modules/notifications/notifications-page';
import { SettingsPage } from '@/modules/settings/settings-page';
import { MapIdentityPage } from '@/modules/settings/map-identity-page';
import { VehiclesPage } from '@/modules/vehicles/vehicles-page';
import { SafetyPage } from '@/modules/safety/safety-page';
import { ReportsPage } from '@/modules/reports/reports-page';
import { BackendErrorCenterPage } from '@/modules/backend-errors/backend-error-center-page';

function Protected() {
  return useAuthStore((state) => state.accessToken) ? <AdminLayout/> : <Navigate to="/login" replace/>;
}

export function AppRouter() {
  return <BrowserRouter><Routes>
    <Route path="/login" element={<LoginPage/>}/>
    <Route element={<Protected/>}>
      <Route index element={<OverviewPage/>}/>
      <Route path="live-monitoring" element={<LiveMonitoringPage/>}/>
      <Route path="convoys" element={<ConvoysPage/>}/>
      <Route path="clubs" element={<ClubsPage/>}/>
      <Route path="members" element={<MembersPage/>}/>
      <Route path="vehicles" element={<VehiclesPage/>}/>
      <Route path="safety" element={<SafetyPage/>}/>
      <Route path="notifications" element={<NotificationsPage/>}/>
      <Route path="reports" element={<ReportsPage/>}/>
      <Route path="backend-errors" element={<BackendErrorCenterPage/>}/>
      <Route path="settings" element={<SettingsPage/>}/>
      <Route path="settings/map-identity" element={<MapIdentityPage/>}/>
      <Route path="groups" element={<Navigate to="/clubs" replace/>}/>
      <Route path="trips" element={<Navigate to="/convoys" replace/>}/>
      <Route path="invite-hub" element={<InviteHubPage/>}/>
      <Route path="invite-hub/create" element={<CreateRidePassPage/>}/>
      <Route path="invite-hub/:passId" element={<RidePassDetailPage/>}/>
      <Route path="invitations" element={<Navigate to="/invite-hub" replace/>}/>
      <Route path="rider-link" element={<RiderLinkPage/>}/>
      <Route path="voice-rooms" element={<VoiceRoomsPage/>}/>
      <Route path="shared-music" element={<MediaSessionsPage/>}/>
      <Route path="audit-logs" element={<ResourcePage title="Audit Logs" path="/api/v1/admin/audit-logs"/>}/>
      <Route path="security-events" element={<ResourcePage title="Security Events" path="/api/v1/admin/security-events"/>}/>
      <Route path="system-health" element={<SystemHealthPage/>}/>
    </Route>
    <Route path="*" element={<Navigate to="/" replace/>}/>
  </Routes></BrowserRouter>;
}
